import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useLoginStyles = createUseStyles((theme: Theme) => {
    return {
        container: {
            width: '100%',
            minHeight: '100vh',
            height: '100vh',
            backgroundColor: theme.colors.espresso_brown,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            padding: '2rem',
             boxSizing: 'border-box',
        },
        formContainer: {
            backgroundColor: theme.colors.ivory_beige,
            padding: 'clamp(2rem, 4vw, 4rem)',
            borderRadius: '0',
            boxShadow: '0 1rem 2rem rgba(0, 0, 0, 0.4)',
            maxWidth: '500px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2rem',
            border: `3px solid ${theme.colors.espresso_brown}`,
            '@media (max-width: 768px)': {
                maxWidth: '90%',
                padding: '2rem',
            },
        },
        logoImage: {
            width: '40%',
            maxWidth: '250px',
            height: 'auto',
            marginBottom: '-1.5rem',
            '@media (max-width: 768px)': {
                width: '70%',
            },
        },
        title: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',
            fontWeight: 700,
            color: theme.colors.espresso_brown,
            textAlign: 'center',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            marginBottom: '-1.5rem',
        },
        subtitle: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1.5rem, 2vw, 1.7rem)',
            fontWeight: 400,
            color: theme.colors.espresso_brown,
            textAlign: 'center',
            marginBottom: '0.5rem',
            opacity: 0.8,
        },
        inputContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
        },
        inputWrapper: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
        },
        label: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
            fontWeight: 600,
            color: theme.colors.espresso_brown,
            textTransform: 'uppercase',
            letterSpacing: '0.05rem',
        },
        input: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.9rem, 1.5vw, 1rem)',
            padding: '1rem',
            border: `2px solid ${theme.colors.espresso_brown}`,
            borderRadius: '5px',
            backgroundColor: 'white',
            color: theme.colors.espresso_brown,
            outline: 'none',
            transition: 'all 0.3s ease',
            '&:focus': {
                borderColor: theme.colors.golden_mustard,
                boxShadow: `0 0 0 3px ${theme.colors.golden_mustard}33`,
            },
            '&::placeholder': {
                color: theme.colors.espresso_brown,
                opacity: 0.5,
            },
        },
        errorText: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(0.85rem, 1.2vw, 0.95rem)',
            fontWeight: 500,
            color: '#d32f2f',
            textAlign: 'center',
            marginTop: '0.5rem',
            padding: '0.75rem',
            backgroundColor: '#ffebee',
            borderRadius: '5px',
            border: '2px solid #d32f2f',
        },
        submitButton: {
            fontFamily: theme.fonts.apex,
            fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
            fontWeight: 700,
            color: theme.colors.ivory_beige,
            backgroundColor: theme.colors.espresso_brown,
            border: `3px solid ${theme.colors.golden_mustard}`,
            borderRadius: '5px',
            padding: '1rem 2rem',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            marginTop: '-1rem',
            width: '80%',
            '&:hover:not(:disabled)': {
                backgroundColor: theme.colors.golden_mustard,
                borderColor: theme.colors.golden_mustard,
                color: theme.colors.espresso_brown,
                transform: 'scale(1.02)',
                boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.3)',
            },
            '&:disabled': {
                opacity: 0.6,
                cursor: 'not-allowed',
            },
        },
    };
});

export default useLoginStyles;